<template>
    <mvtWelcome>
        <template v-slot:img>
            <img :src="glb.cdnUrl + 'vimages/home-report.webp'" alt="Welcome Home Movoto" fetchpriority="auto"/>
        </template>
        <template v-slot:content>
            <b class="f7"> INSTANT HOME VALUATION </b>
            <h1><b class="f0 text-bold">How much is my home worth?</b></h1>
            <div>Find out your home's <a href="javascript:void(0)" class="underdash" @click="openDisclaimer" role="button">estimated worth</a> in today's market with a free valuation.</div>
            <mvtInputGeo class="large default" ref="addressInput" v-model="geoInfo" :placeholder="glb.isPhone ? 'Enter Address' : 'Enter a Home Address'">Get Valuation</mvtInputGeo>
        </template>
    </mvtWelcome>
    <mvtDialog ref="avmDisclaimer" v-ga:dialog>
        <div class="grid xs-grid-cols-1">
            <img loading="lazy" class="dialog-img" :src=" glb.cdnUrl + 'vimages/avm-img.svg'"/>
            <h3 class="text-bold f4">Movoto Interactive Estimate</h3>
            <div>The Movoto Interactive estimate enables you to generate an estimate on the selected property by selecting nearby active or recently sold comparable homes. To improve this estimate, remove homes that are not similar in the Home Value section.</div>
        </div>
    </mvtDialog>
</template>

<script src="./valuation-welcome.js"></script>
